/**
 * @generated SignedSource<<7b448dc54b15d636d1ee874ea93fafb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreQuoteDutiesDescription_shipmentQuote$data = {
  readonly isFromDealer: boolean | null;
  readonly isFromInternal: boolean | null;
  readonly " $fragmentType": "PreQuoteDutiesDescription_shipmentQuote";
};
export type PreQuoteDutiesDescription_shipmentQuote$key = {
  readonly " $data"?: PreQuoteDutiesDescription_shipmentQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteDutiesDescription_shipmentQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreQuoteDutiesDescription_shipmentQuote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFromDealer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFromInternal",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "5b33aaf67eb17a15181715de09eec624";

export default node;
